import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LayoutDashboardIcon, MapPinIcon, ClipboardListIcon, DollarSignIcon, MenuIcon, PlusIcon } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
  title: string;
  subtitle?: string;
}
const bottomNavItems = [{
  id: 'dashboard',
  label: 'Inicio',
  icon: LayoutDashboardIcon
}, {
  id: 'visits',
  label: 'Visitas',
  icon: ClipboardListIcon
}, {
  id: 'new-visit',
  label: 'Nueva',
  icon: PlusIcon,
  primary: true
}, {
  id: 'collections',
  label: 'Cobros',
  icon: DollarSignIcon
}, {
  id: 'more',
  label: 'Más',
  icon: MenuIcon
}];
export function Layout({
  children,
  currentPage,
  onNavigate,
  title,
  subtitle
}: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleBottomNav = (id: string) => {
    if (id === 'more') {
      setSidebarOpen(true);
    } else {
      onNavigate(id);
    }
  };
  const isActiveTab = (id: string) => {
    if (id === 'more') return false;
    return currentPage === id;
  };
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-142">
      {/* Desktop sidebar */}
      <div className="hidden lg:block flex-shrink-0 w-64" data-id="element-143">
        <Sidebar currentPage={currentPage} onNavigate={onNavigate} isOpen={true} onToggle={() => setSidebarOpen(false)} mobileMode={false} data-id="element-144" />
      </div>

      {/* Mobile sidebar (bottom sheet) */}
      <div className="lg:hidden" data-id="element-145">
        <Sidebar currentPage={currentPage} onNavigate={page => {
        onNavigate(page);
        setSidebarOpen(false);
      }} isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} mobileMode={true} data-id="element-146" />
      </div>

      <div className="flex-1 flex flex-col min-h-screen min-w-0" data-id="element-147">
        <Header title={title} subtitle={subtitle} onNavigate={onNavigate} data-id="element-148" />
        <main className="flex-1 p-4 lg:p-8 pb-24 lg:pb-8 overflow-auto" data-id="element-149">
          {children}
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-40 lg:hidden" style={{
      paddingBottom: 'env(safe-area-inset-bottom, 0px)'
    }} data-id="element-150">
        <div className="flex items-end justify-around px-1 pt-1.5 pb-2 border-t border-white/10" style={{
        background: 'linear-gradient(180deg, #0d1332 0%, #0a0f28 100%)'
      }} data-id="element-151">
          {bottomNavItems.map(item => {
          const active = isActiveTab(item.id);
          const Icon = item.icon;
          if (item.primary) {
            return <button key={item.id} onClick={() => handleBottomNav(item.id)} className="flex flex-col items-center justify-center relative -mt-5" aria-label={item.label} data-id="element-152">
                  <motion.div whileTap={{
                scale: 0.9
              }} className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-900/50 ${active ? 'bg-[#2952C4]' : 'bg-gradient-to-br from-[#2952C4] to-[#3B4BC8]'}`} data-id="element-153">
                    <Icon className="w-6 h-6 text-white" strokeWidth={2.5} data-id="element-154" />
                  </motion.div>
                  <span className="text-[10px] font-bold text-white/90 mt-1" data-id="element-155">
                    {item.label}
                  </span>
                </button>;
          }
          return <button key={item.id} onClick={() => handleBottomNav(item.id)} className="flex flex-col items-center justify-center min-w-[56px] py-1.5 relative" aria-label={item.label} data-id="element-156">
                <motion.div whileTap={{
              scale: 0.85
            }} className="relative" data-id="element-157">
                  <Icon className={`w-5 h-5 transition-colors duration-200 ${active ? 'text-[#5483df]' : 'text-slate-400'}`} data-id="element-158" />
                </motion.div>
                <span className={`text-[10px] font-semibold mt-0.5 transition-colors duration-200 ${active ? 'text-[#5483df]' : 'text-slate-500'}`} data-id="element-159">
                  {item.label}
                </span>
                {active && <motion.div layoutId="bottomNavIndicator" className="absolute -top-1.5 w-5 h-0.5 rounded-full bg-[#5483df]" transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-160" />}
              </button>;
        })}
        </div>
      </nav>
    </div>;
}